<template>
  <ContentPanel>
    <ContentWrapper centered-content large-padding class="content-block">
      <IconContainer>
        <FhIcon
          size="md"
          color="warning-default"
          :icon="alertFilled"
          data-test-id="warning-icon"
        />
      </IconContainer>

      <FhText
        tag="h1"
        variant="display-xl"
        data-test-id="waiver-not-available-text"
      >
        {{ T('Waiver not available') }}
      </FhText>

      <FhText
        v-if="!props.isNotExisted"
        variant="body-md"
        data-test-id="contact-us-text"
      >
        {{ T('Contact us for help') }}
      </FhText>
    </ContentWrapper>
  </ContentPanel>
</template>

<script setup>
import { FhIcon, FhText } from '@fareharbor-com/beacon-vue';
import { alertFilled } from '@fareharbor-com/beacon-vue/icons';
import ContentPanel from '../shared/ContentPanel.vue';
import ContentWrapper from '../shared/ContentWrapper.vue';
import IconContainer from '../shared/IconContainer.vue';

const props = defineProps({
  isNotExisted: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.content-block {
  gap: var(--fh-size-md);
}
</style>
